import SigliveServiceSSE from 'Service/sigliveServiceSSE';

const postEndBreak = async (payload) => {
  const { data } = await SigliveServiceSSE({
    method: 'POST',
    url: `/monitoring-operator/break/stop`,
    data: payload,
  });

  return data?.data;
};

export default postEndBreak;
